<template>
    <div
        class="c-radio-wrapper form-check"
        :class="{ 'is-invalid': error, 'border border-radio': bordered, checked: isChecked && bordered }"
    >
        <input
            :id="inputId"
            v-model="_model"
            class="form-check-input"
            type="radio"
            :value="inputValue"
            :disabled="disabled"
        />
        <label class="form-check-label" :for="inputId">
            <template v-if="!slots.default"> {{ label }} </template>
            <slot v-else />
        </label>
    </div>
</template>

<script setup lang="ts">
import { v4 } from 'uuid';
import { computed, useSlots } from 'vue';

const props = defineProps<{
    id?: string;
    label?: string;
    value?: unknown;
    bordered?: boolean;
    inputValue?: unknown;
    error?: boolean;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    (event: 'input', value: unknown): void;
    (event: 'change', value: boolean): void;
}>();

const slots = useSlots();

const id = v4();
const inputId = computed(() => props.id || id);

const _model = computed({
    get: () => props.value,
    set: (value: unknown) => emit('input', value)
});

const isChecked = computed(() => _model.value === props.inputValue);
</script>

<style scoped lang="scss">
@import 'styles/utilities/functions';

.c-radio-wrapper {
    &.checked {
        background-color: get-color('gray-lightest');
    }
    &.border-radio {
        border-radius: 0.5rem;
        padding: 0.75rem 0;
        padding-right: 1rem;
        padding-left: 2rem;
        width: fit-content;
    }
    .form-check-label {
        font-size: 0.825rem;
        cursor: pointer;
    }
    .form-check-input {
        cursor: pointer;
        accent-color: get-color('purple');
    }
}
</style>
